import { LayoutUnit } from '../../models/basic/layoutunit.model';
import { LayoutUnitThickness } from '../../models/basic/layoutunitthickness.model';
import { Alignment } from '../../models/enums/alignment.enum';
import { BorderStyle } from '../../models/enums/borderstyle.enum';
import { EventActionType } from '../../models/enums/eventactiontype.enum';
import { MethodType } from '../../models/enums/methodtype.enum';
import { Orientation } from '../../models/enums/orientation.enum';
import { ProviderChoice } from '../../models/enums/providerchoice.enum';
import { UnitType } from '../../models/enums/unittype.enum';
import { Layout } from '../../models/layout.model';
import { LayoutBase, StyleBase } from '../../models/layoutbase.model';
import { LayoutElement } from '../../models/layoutelement.model';
import { Border } from '../../models/style/border.model';
import { BorderSide } from '../../models/style/borderside.model';
import { Color } from '../../models/style/color.model';
import { Font } from '../../models/style/font.model';
import { Gradient } from '../../models/style/gradient.model';
import { Variable } from '../../models/variable.model';
import { WorkflowData, WorkflowDescription, WorkflowModuleData } from '../../models/workflow/workflow.model';
import { SettingsService } from '../../services/settings.service';
import { DataSwitchSettings, DataSwitchSettingsData } from '../../workflow/modules/dataswitch/dataswitch.settings';
import { DefineMultiValuesSettingsData } from '../../workflow/modules/definevalue/define.multi.values.settings';
import { DefineValueSettings } from '../../workflow/modules/definevalue/define.value.settings';
import { ExecuteWorkflowData, ExecuteWorkflowSettings } from '../../workflow/modules/executeWorkflow/executeWorkflow.settings';
import { SetControlPropertiesSettings, SetControlPropertiesSettingsData } from '../../workflow/modules/layout/elemProperty/set.control.properties.settings';
import { SetMultiElemValueSettings, SetMultiElemValueSettingsData } from '../../workflow/modules/layout/elemValue/set.multi.elem.value.settings';
import { RemoveMultiStyleSettings, RemoveMultiStyleSettingsData } from '../../workflow/modules/layout/setStyle/remove.multi.style.settings';
import { SetMultiStyleSettings, SetMultiStyleSettingsData } from '../../workflow/modules/layout/setStyle/set.multi.style.settings';
import { LoginSettings, LoginSettingsData } from '../../workflow/modules/login/login.settings';
import { ReadMultiPropertySettings, ReadMultiPropertySettingsData } from '../../workflow/modules/readProperty/read.multi.property.settings';
import { RestCallAdvancedSettings, RestCallAdvancedSettingsData } from '../../workflow/modules/restCall/restCall.settings';
import { ExecuteScriptSettings, ExecuteScriptSettingsData } from '../../workflow/modules/script/execute.script.settings';
import { StartWfModuleData, StartWfModuleSettings } from '../../workflow/modules/startend/start.wfmodule';
import { ReadMultiVariableSettingsData } from '../../workflow/modules/variables/readVariable/read.multi.variable.settings';
import { ReadVariableSettings } from '../../workflow/modules/variables/readVariable/readVariable.settings';
import { SetMultiVariableSettingsData } from '../../workflow/modules/variables/setVariable/set.multi.variable.settings';
import { SetVariableSettings } from '../../workflow/modules/variables/setVariable/setVariable.settings';
import { SetWorkflowStatusData, SetWorkflowStatusSettings } from '../../workflow/modules/wfStatus/setWFStatus.settings';

export class LoginLayoutHelper {
    static GetLayout(): Layout {
        //#region Layout
        const l = new Layout();
        l.Visible = true;
        l.Name = 'Login';
        l.BackgroundColor = Gradient.Solid(Color.FromHex('#F9FAFB'));
        l['ElementType'] = 'grid';

        const outerCol = new LayoutBase();
        outerCol.Size = LoginLayoutHelper.GetLayoutUnit(UnitType.fr, 1);
        l['ColumnDefinitions'] = [outerCol];

        const outerRow = new LayoutBase();
        outerRow.Size = LoginLayoutHelper.GetLayoutUnit(UnitType.fr, 1);
        l['RowDefinitions'] = [outerRow];

        const idVar = new Variable();
        idVar.Name = 'ID';
        idVar.Type = 'System.String';

        const mfaVar = new Variable();
        mfaVar.Name = 'MFA';
        mfaVar.Type = 'System.Boolean';
        mfaVar.Formula = 'false';
        l.Variables = [idVar, mfaVar];

        const loading = LoginLayoutHelper.GetLayoutElement('Loading', 'loading', false);
        l.Elements.push(loading);

        const innerGrid = LoginLayoutHelper.GetLayoutElement('InnerGrid', 'grid');

        innerGrid.HorizontalContentAlignment = Alignment.Center;
        innerGrid.VerticalContentAlignment = Alignment.Center;
        innerGrid.Width = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 390);
        innerGrid.Height = LoginLayoutHelper.GetLayoutUnit(UnitType.Auto, 1);
        innerGrid.BackgroundColor = Gradient.Solid(Color.FromHex('#FFFFFF'));
        innerGrid.Border = new Border();
        innerGrid['UseBorder'] = true;
        LoginLayoutHelper.SetBorderRadius(innerGrid.Border, 12);
        innerGrid.Font = new Font();
        innerGrid.Font.FontColor = Color.FromHex('#334155');
        innerGrid.Padding = new LayoutUnitThickness();
        innerGrid.Padding.Left = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 24);
        innerGrid.Padding.Right = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 24);
        innerGrid.Padding.Top = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 30);
        innerGrid.Padding.Bottom = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 30);
        innerGrid['UseDecorationsOnLayout'] = true;
        innerGrid['DropShadow'] = true;
        innerGrid['BoxShadow'] = [{
            "Color": "#000000",
            "ShiftRight": 0,
            "ShiftDown": 3,
            "Blur": 16,
            "Spread": 0,
            "Opacity": 0.16
        }];

        const innerFirstCol = new LayoutBase();
        innerFirstCol.Size = LoginLayoutHelper.GetLayoutUnit(UnitType.fr, 1);
        innerGrid['ColumnDefinitions'] = [innerFirstCol];

        let rowIndex = 1;

        const loginText = LoginLayoutHelper.GetLayoutElement('LoginText', 'textblock');
        loginText.Caption = '@@Login';
        loginText.Row = rowIndex++;
        loginText.Font = new Font();
        loginText.Font.FontSize = 14;
        loginText.Height = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 33);
        loginText.Padding = new LayoutUnitThickness();
        loginText.Padding.Bottom = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 4);
        innerGrid.Elements.push(loginText);

        const loginDesc = LoginLayoutHelper.GetLayoutElement('LoginDescription', 'textblock');
        loginDesc.Caption = '@@EnterUsernamePW';
        loginDesc.Row = rowIndex++;
        loginDesc.Font = new Font();
        loginDesc.Font.FontSize = 11;
        loginDesc.Padding = new LayoutUnitThickness();
        loginDesc.Padding.Bottom = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 16);
        innerGrid.Elements.push(loginDesc);

        const nameGrid = LoginLayoutHelper.GetLoginGrid('NameGrid', rowIndex++);

        const userHeader = LoginLayoutHelper.GetLayoutElement('NameTB', 'textblock');
        userHeader.Caption = '@@Username';
        userHeader.Row = 1;
        userHeader.Column = 2;
        userHeader.Font = new Font();
        userHeader.Font.FontSize = 8;
        userHeader.Padding = new LayoutUnitThickness();
        userHeader.Padding.Bottom = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 4);
        nameGrid.Elements.push(userHeader);

        const userIcon = LoginLayoutHelper.GetLayoutElement('NameIcon', 'icon');
        userIcon.Row = 2;
        userIcon.Column = 1;
        userIcon.VerticalContentAlignment = Alignment.Center;
        userIcon['Icon'] = 'user';
        userIcon.Padding = new LayoutUnitThickness();
        userIcon.Padding.Left = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 6);
        userIcon.Padding.Right = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 8);
        nameGrid.Elements.push(userIcon);

        const nameBox = LoginLayoutHelper.GetLayoutElement('LoginName', 'textbox');
        nameBox.Editable = true;
        nameBox.Row = 2;
        nameBox.Column = 2;
        nameGrid.Elements.push(nameBox);

        innerGrid.Elements.push(nameGrid);

        const pwGrid = LoginLayoutHelper.GetLoginGrid('PWGrid', rowIndex++);

        const pwFlex = LoginLayoutHelper.GetLayoutElement('PWHeaderFlex', 'flex');
        pwFlex.Column = 2;
        pwFlex.Row = 1;
        pwFlex['Orientation'] = Orientation.Horizontal;
        pwFlex.Padding = new LayoutUnitThickness();
        pwFlex.Padding.Bottom = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 4);

        const pwHeader = LoginLayoutHelper.GetLayoutElement('PWTB', 'textblock');
        pwHeader.Caption = '@@Password';
        pwHeader['FlexFill'] = true;
        pwHeader.Font = new Font();
        pwHeader.Font.FontSize = 8;
        pwFlex.Elements.push(pwHeader);

        const forgotPWTB = LoginLayoutHelper.GetLayoutElement('ForgotPWTB', 'textblock');
        forgotPWTB.Editable = true;
        forgotPWTB['Cursor'] = 'pointer';
        forgotPWTB.Font = new Font();
        forgotPWTB.Font.FontColor = Color.FromHex('#3b82f6');
        forgotPWTB.Font.FontSize = 8;
        forgotPWTB.Font.Underline = true;
        forgotPWTB.Caption = '@@ForgotPW';
        pwFlex.Elements.push(forgotPWTB);

        pwGrid.Elements.push(pwFlex);

        const pwIcon = LoginLayoutHelper.GetLayoutElement('PWIcon', 'icon');
        pwIcon.Row = 2;
        pwIcon.Column = 1;
        pwIcon.VerticalContentAlignment = Alignment.Center;
        pwIcon['Icon'] = 'lock';
        pwIcon.Font = new Font();
        pwIcon.Font.FontColor = Color.FromHex('#0F3443');
        pwIcon.Padding = new LayoutUnitThickness();
        pwIcon.Padding.Left = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 6);
        pwIcon.Padding.Right = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 8);
        pwGrid.Elements.push(pwIcon);

        const pwBox = LoginLayoutHelper.GetLayoutElement('LoginPassword', 'textbox');
        pwBox.Editable = true;
        pwBox.Row = 2;
        pwBox.Column = 2;
        pwBox['InputType'] = 'password';
        pwGrid.Elements.push(pwBox);

        innerGrid.Elements.push(pwGrid);

        const providerGrid = LoginLayoutHelper.GetLoginGrid('ProviderGrid', rowIndex++);
        providerGrid.Visible = false;
        providerGrid.Padding = new LayoutUnitThickness();
        providerGrid.Padding.Bottom = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 16);

        const providerHeader = LoginLayoutHelper.GetLayoutElement('ProviderText', 'textblock');
        providerHeader.Caption = '@@LoginProvider';
        providerHeader.Row = 1;
        providerHeader.Column = 2;
        providerHeader.Font = new Font();
        providerHeader.Font.FontSize = 8;
        providerHeader.Padding = new LayoutUnitThickness();
        providerHeader.Padding.Bottom = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 4);
        providerGrid.Elements.push(providerHeader);

        const providerIcon = LoginLayoutHelper.GetLayoutElement('ProviderIcon', 'icon');
        providerIcon.Row = 2;
        providerIcon.Column = 1;
        providerIcon.VerticalContentAlignment = Alignment.Center;
        providerIcon['Icon'] = 'key';
        providerIcon.Padding = new LayoutUnitThickness();
        providerIcon.Padding.Left = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 6);
        providerIcon.Padding.Right = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 8);
        providerGrid.Elements.push(providerIcon);

        const providerBox = LoginLayoutHelper.GetLayoutElement('Providers', 'combobox');
        providerBox.Editable = true;
        providerBox.Row = 2;
        providerBox.Column = 2;
        providerBox['DisplayMemberPath'] = 'Name';
        providerBox.Height = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 42);
        providerGrid.Elements.push(providerBox);

        innerGrid.Elements.push(providerGrid);

        const mfaGrid = LoginLayoutHelper.GetLoginGrid('MFAGrid', rowIndex++);
        mfaGrid.Visible = false;

        const mfaHeader = LoginLayoutHelper.GetLayoutElement('MFAText', 'textblock');
        mfaHeader.Caption = '@@Code';
        mfaHeader.Row = 1;
        mfaHeader.Column = 2;
        mfaHeader.Font = new Font();
        mfaHeader.Font.FontSize = 8;
        mfaHeader.Padding = new LayoutUnitThickness();
        mfaHeader.Padding.Bottom = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 4);
        mfaGrid.Elements.push(mfaHeader);

        const mfaIcon = LoginLayoutHelper.GetLayoutElement('MFAIcon', 'icon');
        mfaIcon.Row = 2;
        mfaIcon.Column = 1;
        mfaIcon.VerticalContentAlignment = Alignment.Center;
        mfaIcon['Icon'] = 'key';
        mfaIcon.Padding = new LayoutUnitThickness();
        mfaIcon.Padding.Left = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 6);
        mfaIcon.Padding.Right = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 8);
        mfaGrid.Elements.push(mfaIcon);

        const mfaBox = LoginLayoutHelper.GetLayoutElement('LoginMFA', 'textbox');
        mfaBox.Editable = true;
        mfaBox.Row = 2;
        mfaBox.Column = 2;
        mfaGrid.Elements.push(mfaBox);

        innerGrid.Elements.push(mfaGrid);

        const errorGrid = LoginLayoutHelper.GetLayoutElement('ErrorGrid', 'grid', false);
        errorGrid.Row = rowIndex++;
        const errorGridFirstCol = new LayoutBase();
        errorGridFirstCol.Size = LoginLayoutHelper.GetLayoutUnit(UnitType.Auto, 1);
        const errorGridSecondCol = new LayoutBase();
        errorGridSecondCol.Size = LoginLayoutHelper.GetLayoutUnit(UnitType.fr, 1);
        errorGrid['ColumnDefinitions'] = [errorGridFirstCol, errorGridSecondCol];
        const errorGridFirstRow = new LayoutBase();
        errorGridFirstRow.Size = LoginLayoutHelper.GetLayoutUnit(UnitType.Auto, 1);
        errorGrid['RowDefinitions'] = [errorGridFirstRow];
        LoginLayoutHelper.SetBorder(errorGrid, 1, BorderStyle.Solid, '#fecaca');
        LoginLayoutHelper.SetBorderRadius(errorGrid.Border, 6);
        errorGrid.BackgroundColor = Gradient.Solid(Color.FromHex('#fef2f2f2'));
        errorGrid.Padding = new LayoutUnitThickness();
        errorGrid.Padding.Bottom = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 16);

        const errorIcon = LoginLayoutHelper.GetLayoutElement('ErrorIcon', 'icon');
        errorIcon.Column = 1;
        errorIcon.Row = 1;
        errorIcon.Font = new Font();
        errorIcon.Font.FontColor = Color.FromHex('#dc2626');
        errorIcon.Padding = new LayoutUnitThickness();
        errorIcon.Padding.Left = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 6);
        errorIcon.Padding.Right = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 8);
        errorIcon['Icon'] = 'cancel';
        errorIcon.VerticalContentAlignment = Alignment.Center;
        errorGrid.Elements.push(errorIcon);

        const errorText = LoginLayoutHelper.GetLayoutElement('ErrorText', 'textblock');
        errorText.Column = 2;
        errorText.Row = 1;
        errorText.Font = new Font();
        errorText.Font.FontColor = Color.FromHex('#dc2626');
        errorText.Font.FontSize = 11;
        errorText.Padding = new LayoutUnitThickness();
        errorText.Padding.Top = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 10);
        errorText.Padding.Bottom = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, 10);
        errorGrid.Elements.push(errorText);

        innerGrid.Elements.push(errorGrid);

        const loginButton = LoginLayoutHelper.GetLayoutElement('LoginButton', 'button');
        loginButton.Editable = true;
        loginButton.Row = rowIndex;
        loginButton.Caption = '@@Login';
        loginButton['ButtonType'] = 'mat-button';
        loginButton.BackgroundColor = Gradient.Solid(Color.FromHex('#2bee82'));
        loginButton.Font = new Font();
        loginButton.Font.FontColor = Color.FromHex('#113342');
        innerGrid.Elements.push(loginButton);

        const innerRows = [];
        for (let i = 0; i < rowIndex; i++) {
            const innerRow = new LayoutBase();
            innerRow.Size = LoginLayoutHelper.GetLayoutUnit(UnitType.Auto, 1);
            innerRows.push(innerRow);
        }
        innerGrid['RowDefinitions'] = innerRows;

        l.Elements.push(innerGrid);
        //#endregion

        //#region Workflows
        let wfID = 0;

        //#region ForgotPW
        const forgotStartID = wfID++;
        const forgotPW = LoginLayoutHelper.GetWFDescription('ForgotPW',
            '31607f64-b71b-a525-6b7b-56a968f8ff4d', forgotStartID);

        const forgotNavigate = LoginLayoutHelper.GetWFModule(wfID++);
        forgotNavigate.Module = 'navigateToForgotPWModule';
        forgotNavigate.Settings = {};
        forgotPW.Data.Modules.push(forgotNavigate);

        forgotPW.Data.Connectors.push({
            ExitModule: forgotStartID,
            EntryModule: forgotNavigate.ID,
            EntryOption: 0,
            ExitOption: 0
        });

        l.Workflows.push(forgotPW);

        forgotPWTB.Events.push({
            EventID: 'MouseClick',
            Handlers: [
                {
                    ActionType: EventActionType.Workflow,
                    Action: forgotPW.ID
                }
            ]
        });
        //#endregion

        //#region InitProviders
        wfID = 0;
        const initStartID = wfID++;
        const initWorkflow = LoginLayoutHelper.GetWFDescription('InitProviders',
            '23cfafd8-c3d9-41ed-8ae7-7f2bb26aa73f', initStartID);

        const initRest = new RestCallAdvancedSettingsData();
        initRest.UseServiceURL = true;
        initRest.Type = MethodType.Get;
        initRest.Path = '"config/api/security/GetSecurityProviders?apibase=' + SettingsService.API_BASE_URL.getValue() + '"';
        const initRestModule = LoginLayoutHelper.GetWFModule(wfID++);
        initRestModule.Module = RestCallAdvancedSettings.ModuleID;
        initRestModule.Settings = initRest;
        initWorkflow.Data.Modules.push(initRestModule);

        const initSetStatus = new SetWorkflowStatusData();
        initSetStatus.StatusKey = 'providers';
        const initSetStatusModule = LoginLayoutHelper.GetWFModule(wfID++);
        initSetStatusModule.Module = SetWorkflowStatusSettings.ModuleID;
        initSetStatusModule.Settings = initSetStatus;
        initWorkflow.Data.Modules.push(initSetStatusModule);

        const initSetProp = new SetControlPropertiesSettingsData();
        initSetProp.Controls.push({
            ControlName: providerBox.Name,
            Properties: [
                {
                    PropertyName: 'ItemsSource',
                    Formula: initSetStatus.StatusKey
                }
            ]
        });
        const initSetPropModule = LoginLayoutHelper.GetWFModule(wfID++);
        initSetPropModule.Module = SetControlPropertiesSettings.ModuleID;
        initSetPropModule.Settings = initSetProp;
        initWorkflow.Data.Modules.push(initSetPropModule);

        const initScriptProp = new ExecuteScriptSettingsData();
        initScriptProp.ID = '9c3cf944-8183-912b-fc4e-e2518397dc26';
        initScriptProp.UseJObject = false;
        initScriptProp.Script = 'import { Global } from "System";\r\nexport class Main {\r\n    constructor() {\r\n    }\r\n    run(): any {\r\n        let status = Global.getStatus();\r\n        let providers = status["providers"];\r\n        if (providers != null && providers.length > 0) {\r\n            status["multiProviders"] = providers.length > 1;\r\n            for (let p of providers) {\r\n                if (p.IsDefault) {\r\n                    return p;\r\n                }\r\n            }\r\n            return providers[0];\r\n        }\r\n        status["multiProviders"] = false;\r\n        return null;\r\n    }\r\n    stop(): void {\r\n    }\r\n}';
        const initScriptModule = LoginLayoutHelper.GetWFModule(wfID++);
        initScriptModule.Module = ExecuteScriptSettings.ModuleID;
        initScriptModule.Settings = initScriptProp;
        initWorkflow.Data.Modules.push(initScriptModule);

        const initSetValueProp = new SetMultiElemValueSettingsData();
        initSetValueProp.Elements.push({
            ElemName: providerBox.Name,
            GetFromState: true,
            StatusKey: null
        });
        const initSetValueModule = LoginLayoutHelper.GetWFModule(wfID++);
        initSetValueModule.Module = SetMultiElemValueSettings.ModuleID;
        initSetValueModule.Settings = initSetValueProp;
        initWorkflow.Data.Modules.push(initSetValueModule);

        const selChangeWFID = 'c760d1eb-f7e8-4e74-b1dd-7724aebc585a';

        const initExecWF = new ExecuteWorkflowData();
        initExecWF.WorkflowID = selChangeWFID;
        const initExecWFModule = LoginLayoutHelper.GetWFModule(wfID++);
        initExecWFModule.Module = ExecuteWorkflowSettings.ModuleID;
        initExecWFModule.Settings = initExecWF;
        initWorkflow.Data.Modules.push(initExecWFModule);

        const initDataSwitchProps = new DataSwitchSettingsData();
        initDataSwitchProps.Conditions.push({
            Formula: 'multiProviders',
            Name: 'multiProviders'
        });
        const initDataSwitchModule = LoginLayoutHelper.GetWFModule(wfID++);
        initDataSwitchModule.Module = DataSwitchSettings.ModuleID;
        initDataSwitchModule.Settings = initDataSwitchProps;
        initWorkflow.Data.Modules.push(initDataSwitchModule);

        const provStyle = new StyleBase();
        provStyle.Visible = true;
        const initSetProvStyle = new SetMultiStyleSettingsData();
        initSetProvStyle.Styles.push({
            Elements: [{ ElemName: providerGrid.Name }],
            Layout: provStyle,
            StyleRef: null
        });
        const initSetProvStyleModule = LoginLayoutHelper.GetWFModule(wfID++);
        initSetProvStyleModule.Module = SetMultiStyleSettings.ModuleID;
        initSetProvStyleModule.Settings = initSetProvStyle;
        initWorkflow.Data.Modules.push(initSetProvStyleModule);

        initWorkflow.Data.Connectors.push({
            ExitModule: initStartID,
            EntryModule: initRestModule.ID,
            EntryOption: 0,
            ExitOption: 0
        });
        initWorkflow.Data.Connectors.push({
            ExitModule: initRestModule.ID,
            EntryModule: initSetStatusModule.ID,
            EntryOption: 0,
            ExitOption: 0
        });
        initWorkflow.Data.Connectors.push({
            ExitModule: initSetStatusModule.ID,
            EntryModule: initSetPropModule.ID,
            EntryOption: 0,
            ExitOption: 0
        });
        initWorkflow.Data.Connectors.push({
            ExitModule: initSetPropModule.ID,
            EntryModule: initScriptModule.ID,
            EntryOption: 0,
            ExitOption: 0
        });
        initWorkflow.Data.Connectors.push({
            ExitModule: initScriptModule.ID,
            EntryModule: initSetValueModule.ID,
            EntryOption: 0,
            ExitOption: 0
        });
        initWorkflow.Data.Connectors.push({
            ExitModule: initSetValueModule.ID,
            EntryModule: initExecWFModule.ID,
            EntryOption: 0,
            ExitOption: 0
        });
        initWorkflow.Data.Connectors.push({
            ExitModule: initExecWFModule.ID,
            EntryModule: initDataSwitchModule.ID,
            EntryOption: 0,
            ExitOption: 0
        });
        initWorkflow.Data.Connectors.push({
            ExitModule: initDataSwitchModule.ID,
            EntryModule: initSetProvStyleModule.ID,
            EntryOption: 0,
            ExitOption: 1
        });

        l.Workflows.push(initWorkflow);

        l.Events.push({
            EventID: 'OnInit',
            Handlers: [
                {
                    ActionType: EventActionType.Workflow,
                    Action: initWorkflow.ID
                }
            ]
        });
        //#endregion

        wfID = 0;
        //#region Login
        const loginStartID = wfID++;
        const loginWF = LoginLayoutHelper.GetWFDescription('Login',
            '990f0512-d66f-4573-ba48-8993dce3441d', loginStartID);

        const loginReadVar = new ReadMultiVariableSettingsData();
        loginReadVar.Variables.push({
            ElemName: l.Name,
            Variable: idVar.Name,
            StatusKey: 'providerID',
            UseForState: false
        });
        loginReadVar.Variables.push({
            ElemName: l.Name,
            Variable: mfaVar.Name,
            StatusKey: 'mfa',
            UseForState: false
        });
        const loginReadVarModule = new WorkflowModuleData();
        loginReadVarModule.ID = wfID++;
        loginReadVarModule.XPos = 260;
        loginReadVarModule.YPos = 145;
        loginReadVarModule.Module = ReadVariableSettings.MultiModuleID;
        loginReadVarModule.Settings = loginReadVar;
        loginWF.Data.Modules.push(loginReadVarModule);

        const login = new LoginSettingsData();
        login.UseControlForName = true;
        login.Name = nameBox.Name;
        login.UseControlForPassword = true;
        login.Password = pwBox.Name;
        login.UseControlForMFACode = true;
        login.MFACode = mfaBox.Name;
        login.ProviderChoice = ProviderChoice.Formula;
        login.Provider = 'providerID';
        const loginModule = new WorkflowModuleData();
        loginModule.ID = wfID++;
        loginModule.XPos = 260;
        loginModule.YPos = 265;
        loginModule.Module = LoginSettings.ModuleID;
        loginModule.Settings = login;
        loginWF.Data.Modules.push(loginModule);

        const wrongPW = new SetControlPropertiesSettingsData();
        wrongPW.Controls.push({
            ControlName: errorText.Name,
            Properties: [{
                Formula: 'translate("@@WrongPW")',
                PropertyName: 'Caption'
            }]
        });
        const wrongPWModule = new WorkflowModuleData();
        wrongPWModule.ID = wfID++;
        wrongPWModule.XPos = 50;
        wrongPWModule.YPos = 385;
        wrongPWModule.Module = SetControlPropertiesSettings.ModuleID;
        wrongPWModule.Settings = wrongPW;
        loginWF.Data.Modules.push(wrongPWModule);

        const unauthorized = new SetControlPropertiesSettingsData();
        unauthorized.Controls.push({
            ControlName: errorText.Name,
            Properties: [{
                Formula: 'translate("@@NoLoginRight")',
                PropertyName: 'Caption'
            }]
        });
        const unauthorizedModule = new WorkflowModuleData();
        unauthorizedModule.ID = wfID++;
        unauthorizedModule.XPos = 260;
        unauthorizedModule.YPos = 415;
        unauthorizedModule.Module = SetControlPropertiesSettings.ModuleID;
        unauthorizedModule.Settings = unauthorized;
        loginWF.Data.Modules.push(unauthorizedModule);

        const disabled = new SetControlPropertiesSettingsData();
        disabled.Controls.push({
            ControlName: errorText.Name,
            Properties: [{
                Formula: 'translate("@@InactiveUser")',
                PropertyName: 'Caption'
            }]
        });
        const disabledModule = new WorkflowModuleData();
        disabledModule.ID = wfID++;
        disabledModule.XPos = 470;
        disabledModule.YPos = 385;
        disabledModule.Module = SetControlPropertiesSettings.ModuleID;
        disabledModule.Settings = disabled;
        loginWF.Data.Modules.push(disabledModule);

        const error = new SetMultiStyleSettingsData();
        const style = new StyleBase();
        style.Visible = true;
        error.Styles.push({
            Elements: [
                {
                    ElemName: errorGrid.Name
                }
            ],
            Layout: style,
            StyleRef: null
        });
        const errorModule = new WorkflowModuleData();
        errorModule.ID = wfID++;
        errorModule.XPos = 260;
        errorModule.YPos = 535;
        errorModule.Module = SetMultiStyleSettings.ModuleID;
        errorModule.Settings = error;
        loginWF.Data.Modules.push(errorModule);

        const loginDataSwitch = new DataSwitchSettingsData();
        loginDataSwitch.Conditions.push({
            Name: 'MFA',
            Formula: 'mfa'
        });
        const loginDataSwitchModule = new WorkflowModuleData();
        loginDataSwitchModule.ID = wfID++;
        loginDataSwitchModule.XPos = 825;
        loginDataSwitchModule.YPos = 195;
        loginDataSwitchModule.Module = DataSwitchSettings.ModuleID;
        loginDataSwitchModule.Settings = loginDataSwitch;
        loginWF.Data.Modules.push(loginDataSwitchModule);

        const mfaText = new SetControlPropertiesSettingsData();
        mfaText.Controls.push({
            ControlName: errorText.Name,
            Properties: [{
                Formula: 'translate("@@WrongCode")',
                PropertyName: 'Caption'
            }]
        });
        const mfaModule = new WorkflowModuleData();
        mfaModule.ID = wfID++;
        mfaModule.XPos = 680;
        mfaModule.YPos = 385;
        mfaModule.Module = SetControlPropertiesSettings.ModuleID;
        mfaModule.Settings = mfaText;
        loginWF.Data.Modules.push(mfaModule);

        const mfaCaption = new SetControlPropertiesSettingsData();
        mfaCaption.Controls.push({
            ControlName: loginText.Name,
            Properties: [{
                Formula: 'translate("@@Authentication")',
                PropertyName: 'Caption'
            }]
        });
        mfaCaption.Controls.push({
            ControlName: loginDesc.Name,
            Properties: [{
                Formula: 'translate("@@EnterAuthCode")',
                PropertyName: 'Caption'
            }]
        });
        const mfaCaptionModule = new WorkflowModuleData();
        mfaCaptionModule.ID = wfID++;
        mfaCaptionModule.XPos = 890;
        mfaCaptionModule.YPos = 385;
        mfaCaptionModule.Module = SetControlPropertiesSettings.ModuleID;
        mfaCaptionModule.Settings = mfaCaption;
        loginWF.Data.Modules.push(mfaCaptionModule);

        const mfaActive = new SetMultiStyleSettingsData();
        const mfaActiveStyle = new StyleBase();
        mfaActiveStyle.Visible = true;
        const mfaInActiveStyle = new StyleBase();
        mfaInActiveStyle.Visible = false;
        mfaActive.Styles.push({
            Elements: [
                {
                    ElemName: mfaGrid.Name
                }
            ],
            Layout: mfaActiveStyle,
            StyleRef: null
        });
        mfaActive.Styles.push({
            Elements: [
                {
                    ElemName: nameGrid.Name
                },
                {
                    ElemName: pwGrid.Name
                },
                {
                    ElemName: providerGrid.Name
                }
            ],
            Layout: mfaInActiveStyle,
            StyleRef: null
        });
        const mfaActiveModule = new WorkflowModuleData();
        mfaActiveModule.ID = wfID++;
        mfaActiveModule.XPos = 890;
        mfaActiveModule.YPos = 505;
        mfaActiveModule.Module = SetMultiStyleSettings.ModuleID;
        mfaActiveModule.Settings = mfaActive;
        loginWF.Data.Modules.push(mfaActiveModule);

        const loginSetVar = new SetMultiVariableSettingsData();
        loginSetVar.Elements.push({
            ElemName: l.Name,
            Variables: [
                {
                    Name: mfaVar.Name,
                    UseActualParam: false,
                    UseVariable: false,
                    Value: 'true'
                }
            ]
        });
        const loginSetVarModule = new WorkflowModuleData();
        loginSetVarModule.ID = wfID++;
        loginSetVarModule.XPos = 890;
        loginSetVarModule.YPos = 625;
        loginSetVarModule.Module = SetVariableSettings.MultiModuleID;
        loginSetVarModule.Settings = loginSetVar;
        loginWF.Data.Modules.push(loginSetVarModule);

        const loginSuccessSetVar = new SetMultiVariableSettingsData();
        loginSuccessSetVar.Elements.push({
            ElemName: l.Name,
            Variables: [
                {
                    Name: mfaVar.Name,
                    UseActualParam: false,
                    UseVariable: false,
                    Value: 'false'
                }
            ]
        });
        const loginSuccessSetVarModule = new WorkflowModuleData();
        loginSuccessSetVarModule.ID = wfID++;
        loginSuccessSetVarModule.XPos = 39;
        loginSuccessSetVarModule.YPos = 240;
        loginSuccessSetVarModule.Module = SetVariableSettings.MultiModuleID;
        loginSuccessSetVarModule.Settings = loginSuccessSetVar;
        loginWF.Data.Modules.push(loginSuccessSetVarModule);


        const loadingActive = new SetMultiStyleSettingsData();
        const loadingActiveStyle = new StyleBase();
        loadingActiveStyle.Visible = true;
        loadingActive.Styles.push({
            Elements: [
                {
                    ElemName: loading.Name
                }
            ],
            Layout: loadingActiveStyle,
            StyleRef: null
        });
        const loadingActiveModule = new WorkflowModuleData();
        loadingActiveModule.ID = wfID++;
        loadingActiveModule.XPos = 47;
        loadingActiveModule.YPos = 111;
        loadingActiveModule.Module = SetMultiStyleSettings.ModuleID;
        loadingActiveModule.Settings = loadingActive;
        loginWF.Data.Modules.push(loadingActiveModule);

        const loadingInActive = new RemoveMultiStyleSettingsData();
        loadingInActive.Elements.push({ ElemName: loading.Name });
        const loadingInActiveModule = new WorkflowModuleData();
        loadingInActiveModule.ID = wfID++;
        loadingInActiveModule.XPos = 66;
        loadingInActiveModule.YPos = 633;
        loadingInActiveModule.Module = RemoveMultiStyleSettings.ModuleID;
        loadingInActiveModule.Settings = loadingInActive;
        loginWF.Data.Modules.push(loadingInActiveModule);


        loginWF.Data.Connectors.push({
            ExitModule: loginStartID,
            EntryModule: loadingActiveModule.ID,
            EntryOption: 0,
            ExitOption: 0
        });
        loginWF.Data.Connectors.push({
            ExitModule: loadingActiveModule.ID,
            EntryModule: loginReadVarModule.ID,
            EntryOption: 0,
            ExitOption: 0
        });
        loginWF.Data.Connectors.push({
            ExitModule: loginReadVarModule.ID,
            EntryModule: loginModule.ID,
            EntryOption: 0,
            ExitOption: 0
        });
        loginWF.Data.Connectors.push({
            ExitModule: loginModule.ID,
            EntryModule: loginSuccessSetVarModule.ID,
            EntryOption: 0,
            ExitOption: 0
        });
        loginWF.Data.Connectors.push({
            ExitModule: loginModule.ID,
            EntryModule: wrongPWModule.ID,
            EntryOption: 0,
            ExitOption: 1
        });
        loginWF.Data.Connectors.push({
            ExitModule: loginModule.ID,
            EntryModule: unauthorizedModule.ID,
            EntryOption: 0,
            ExitOption: 2
        });
        loginWF.Data.Connectors.push({
            ExitModule: loginModule.ID,
            EntryModule: disabledModule.ID,
            EntryOption: 0,
            ExitOption: 3
        });
        loginWF.Data.Connectors.push({
            ExitModule: wrongPWModule.ID,
            EntryModule: errorModule.ID,
            EntryOption: 0,
            ExitOption: 0
        });
        loginWF.Data.Connectors.push({
            ExitModule: unauthorizedModule.ID,
            EntryModule: errorModule.ID,
            EntryOption: 0,
            ExitOption: 0
        });
        loginWF.Data.Connectors.push({
            ExitModule: disabledModule.ID,
            EntryModule: errorModule.ID,
            EntryOption: 0,
            ExitOption: 0
        });
        loginWF.Data.Connectors.push({
            ExitModule: loginModule.ID,
            EntryModule: loginDataSwitchModule.ID,
            EntryOption: 0,
            ExitOption: 4
        });
        loginWF.Data.Connectors.push({
            ExitModule: loginDataSwitchModule.ID,
            EntryModule: mfaCaptionModule.ID,
            EntryOption: 0,
            ExitOption: 0
        });
        loginWF.Data.Connectors.push({
            ExitModule: mfaCaptionModule.ID,
            EntryModule: mfaActiveModule.ID,
            EntryOption: 0,
            ExitOption: 0
        });
        loginWF.Data.Connectors.push({
            ExitModule: mfaActiveModule.ID,
            EntryModule: loginSetVarModule.ID,
            EntryOption: 0,
            ExitOption: 0
        });
        loginWF.Data.Connectors.push({
            ExitModule: loginDataSwitchModule.ID,
            EntryModule: mfaModule.ID,
            EntryOption: 0,
            ExitOption: 1
        });
        loginWF.Data.Connectors.push({
            ExitModule: mfaModule.ID,
            EntryModule: errorModule.ID,
            EntryOption: 0,
            ExitOption: 0
        });
        loginWF.Data.Connectors.push({
            ExitModule: loginSuccessSetVarModule.ID,
            EntryModule: loadingInActiveModule.ID,
            EntryOption: 0,
            ExitOption: 0
        });
        loginWF.Data.Connectors.push({
            ExitModule: errorModule.ID,
            EntryModule: loadingInActiveModule.ID,
            EntryOption: 0,
            ExitOption: 0
        });
        loginWF.Data.Connectors.push({
            ExitModule: loginSetVarModule.ID,
            EntryModule: loadingInActiveModule.ID,
            EntryOption: 0,
            ExitOption: 0
        });

        l.Workflows.push(loginWF);

        loginButton.Events.push({
            EventID: 'click',
            Handlers: [
                {
                    ActionType: EventActionType.Workflow,
                    Action: loginWF.ID
                }
            ]
        });
        //#endregion
        wfID = 0;
        //#region OnEnter
        const keyDownStartID = wfID++;
        const keyDownWF = LoginLayoutHelper.GetWFDescription('OnEnter',
            '937cdff9-71c9-4873-910d-b6ac1e2fd55d', keyDownStartID);

        const readProps = new ReadMultiPropertySettingsData();
        readProps.Properties.push({
            PropName: 'key',
            StatusKey: 'key',
            UseForState: false
        });
        const readPropsModule = LoginLayoutHelper.GetWFModule(wfID++);
        readPropsModule.Module = ReadMultiPropertySettings.ModuleID;
        readPropsModule.Settings = readProps;
        keyDownWF.Data.Modules.push(readPropsModule);

        const dataSwitch = new DataSwitchSettingsData();
        dataSwitch.Conditions.push({
            Name: 'Enter',
            Formula: 'key="Enter"'
        });
        const dataSwitchModule = LoginLayoutHelper.GetWFModule(wfID++);
        dataSwitchModule.Module = 'dataswitchWFModule';
        dataSwitchModule.Settings = dataSwitch;
        keyDownWF.Data.Modules.push(dataSwitchModule);

        const execWF = new ExecuteWorkflowData();
        execWF.WorkflowID = loginWF.ID;
        const execWFModule = LoginLayoutHelper.GetWFModule(wfID++);
        execWFModule.Module = 'execWFModule';
        execWFModule.Settings = execWF;
        keyDownWF.Data.Modules.push(execWFModule);

        const keyDownRemoveStyle = new RemoveMultiStyleSettingsData();
        keyDownRemoveStyle.Elements.push({ ElemName: errorGrid.Name });
        const keyDownRemoveStyleModule = LoginLayoutHelper.GetWFModule(wfID++);
        keyDownRemoveStyleModule.Module = RemoveMultiStyleSettings.ModuleID;
        keyDownRemoveStyleModule.Settings = keyDownRemoveStyle;
        keyDownWF.Data.Modules.push(keyDownRemoveStyleModule);

        keyDownWF.Data.Connectors.push({
            ExitModule: keyDownStartID,
            EntryModule: readPropsModule.ID,
            EntryOption: 0,
            ExitOption: 0
        });
        keyDownWF.Data.Connectors.push({
            ExitModule: readPropsModule.ID,
            EntryModule: dataSwitchModule.ID,
            EntryOption: 0,
            ExitOption: 0
        });
        keyDownWF.Data.Connectors.push({
            ExitModule: dataSwitchModule.ID,
            EntryModule: execWFModule.ID,
            EntryOption: 0,
            ExitOption: 1
        });
        keyDownWF.Data.Connectors.push({
            ExitModule: dataSwitchModule.ID,
            EntryModule: keyDownRemoveStyleModule.ID,
            EntryOption: 0,
            ExitOption: 0
        });

        nameBox.Events.push({
            EventID: 'keydown',
            Handlers: [
                {
                    ActionType: EventActionType.Workflow,
                    Action: keyDownWF.ID
                }
            ]
        });

        pwBox.Events.push({
            EventID: 'keydown',
            Handlers: [
                {
                    ActionType: EventActionType.Workflow,
                    Action: keyDownWF.ID
                }
            ]
        });

        mfaBox.Events.push({
            EventID: 'keydown',
            Handlers: [
                {
                    ActionType: EventActionType.Workflow,
                    Action: keyDownWF.ID
                }
            ]
        });

        l.Workflows.push(keyDownWF);
        //#endregion
        wfID = 0;
        //#region ProviderChanged
        const selChangeStartID = wfID++;
        const selChangeWF = LoginLayoutHelper.GetWFDescription('ProviderChanged',
            selChangeWFID, selChangeStartID);

        const selChangeSetStatusProps = new SetWorkflowStatusData();
        selChangeSetStatusProps.StatusKey = 'selectedProvider';
        selChangeSetStatusProps.KeepActualParam = true;
        const selChangeSetStatusModule = LoginLayoutHelper.GetWFModule(wfID++);
        selChangeSetStatusModule.Module = SetWorkflowStatusSettings.ModuleID;
        selChangeSetStatusModule.Settings = selChangeSetStatusProps;
        selChangeWF.Data.Modules.push(selChangeSetStatusModule);

        const selDefValuesProps = new DefineMultiValuesSettingsData();
        selDefValuesProps.Values.push({
            Formula: 'GenerateNull()',
            StatusKey: 'propID',
            UseForState: false
        });
        selDefValuesProps.Values.push({
            Formula: 'GenerateNull()',
            StatusKey: 'propURL',
            UseForState: false
        });
        selDefValuesProps.Values.push({
            Formula: '""',
            StatusKey: 'propType',
            UseForState: false
        });
        const selDefValuesModule = LoginLayoutHelper.GetWFModule(wfID++);
        selDefValuesModule.Module = DefineValueSettings.MultiModuleID;
        selDefValuesModule.Settings = selDefValuesProps;
        selChangeWF.Data.Modules.push(selDefValuesModule);

        const selRemoveStyle = new RemoveMultiStyleSettingsData();
        selRemoveStyle.Elements.push({ ElemName: nameGrid.Name });
        selRemoveStyle.Elements.push({ ElemName: pwGrid.Name });
        const selRemoveStyleModule = LoginLayoutHelper.GetWFModule(wfID++);
        selRemoveStyleModule.Module = RemoveMultiStyleSettings.ModuleID;
        selRemoveStyleModule.Settings = selRemoveStyle;
        selChangeWF.Data.Modules.push(selRemoveStyleModule);

        const selFirstDataSwitchProps = new DataSwitchSettingsData();
        selFirstDataSwitchProps.Conditions.push({
            Formula: 'IsNull(selectedProvider)',
            Name: 'isNull'
        });
        const selFirstDataSwitchModule = LoginLayoutHelper.GetWFModule(wfID++);
        selFirstDataSwitchModule.Module = DataSwitchSettings.ModuleID;
        selFirstDataSwitchModule.Settings = selFirstDataSwitchProps;
        selChangeWF.Data.Modules.push(selFirstDataSwitchModule);

        const selReadProps = new ReadMultiPropertySettingsData();
        selReadProps.Properties.push({
            PropName: 'Id',
            StatusKey: 'propID',
            UseForState: false
        });
        selReadProps.Properties.push({
            PropName: 'Url',
            StatusKey: 'propURL',
            UseForState: false
        });
        selReadProps.Properties.push({
            PropName: 'Type',
            StatusKey: 'propType',
            UseForState: false
        });
        const selReadPropsModule = LoginLayoutHelper.GetWFModule(wfID++);
        selReadPropsModule.Module = ReadMultiPropertySettings.ModuleID;
        selReadPropsModule.Settings = selReadProps;
        selChangeWF.Data.Modules.push(selReadPropsModule);

        const selSetVar = new SetMultiVariableSettingsData();
        selSetVar.Elements.push({
            ElemName: l.Name,
            Variables: [
                {
                    Name: idVar.Name,
                    UseActualParam: false,
                    UseVariable: false,
                    Value: 'propID'
                }
            ]
        });
        const selSetVarModule = LoginLayoutHelper.GetWFModule(wfID++);
        selSetVarModule.Module = SetVariableSettings.MultiModuleID;
        selSetVarModule.Settings = selSetVar;
        selChangeWF.Data.Modules.push(selSetVarModule);

        const selDataSwitch = new DataSwitchSettingsData();
        selDataSwitch.Conditions.push({
            Name: 'HasUrl',
            Formula: 'Or(IsNull(propURL);propURL="")=false'
        });
        selDataSwitch.Conditions.push({
            Name: 'IsScan',
            Formula: 'propType="31e75470-8458-48e5-af70-d8a6e8840b37"'
        });
        const selDataSwitchModule = LoginLayoutHelper.GetWFModule(wfID++);
        selDataSwitchModule.Module = DataSwitchSettings.ModuleID;
        selDataSwitchModule.Settings = selDataSwitch;
        selChangeWF.Data.Modules.push(selDataSwitchModule);

        const nameStyle = new StyleBase();
        nameStyle.Visible = false;
        const selSetNameStyle = new SetMultiStyleSettingsData();
        selSetNameStyle.Styles.push({
            Elements: [{ ElemName: nameGrid.Name }],
            Layout: nameStyle,
            StyleRef: null
        });
        const selSetNameStyleModule = LoginLayoutHelper.GetWFModule(wfID++);
        selSetNameStyleModule.Module = SetMultiStyleSettings.ModuleID;
        selSetNameStyleModule.Settings = selSetNameStyle;
        selChangeWF.Data.Modules.push(selSetNameStyleModule);

        const pwStyle = new StyleBase();
        pwStyle.Visible = false;
        const selSetPWStyle = new SetMultiStyleSettingsData();
        selSetPWStyle.Styles.push({
            Elements: [{ ElemName: pwGrid.Name }],
            Layout: pwStyle,
            StyleRef: null
        });
        const selSetPWStyleModule = LoginLayoutHelper.GetWFModule(wfID++);
        selSetPWStyleModule.Module = SetMultiStyleSettings.ModuleID;
        selSetPWStyleModule.Settings = selSetPWStyle;
        selChangeWF.Data.Modules.push(selSetPWStyleModule);

        selChangeWF.Data.Connectors.push({
            ExitModule: selChangeStartID,
            EntryModule: selChangeSetStatusModule.ID,
            EntryOption: 0,
            ExitOption: 0
        });
        selChangeWF.Data.Connectors.push({
            ExitModule: selChangeSetStatusModule.ID,
            EntryModule: selDefValuesModule.ID,
            EntryOption: 0,
            ExitOption: 0
        });
        selChangeWF.Data.Connectors.push({
            ExitModule: selDefValuesModule.ID,
            EntryModule: selRemoveStyleModule.ID,
            EntryOption: 0,
            ExitOption: 0
        });
        selChangeWF.Data.Connectors.push({
            ExitModule: selRemoveStyleModule.ID,
            EntryModule: selFirstDataSwitchModule.ID,
            EntryOption: 0,
            ExitOption: 0
        });
        selChangeWF.Data.Connectors.push({
            ExitModule: selFirstDataSwitchModule.ID,
            EntryModule: selReadPropsModule.ID,
            EntryOption: 0,
            ExitOption: 0
        });
        selChangeWF.Data.Connectors.push({
            ExitModule: selFirstDataSwitchModule.ID,
            EntryModule: selSetVarModule.ID,
            EntryOption: 0,
            ExitOption: 1
        });
        selChangeWF.Data.Connectors.push({
            ExitModule: selReadPropsModule.ID,
            EntryModule: selSetVarModule.ID,
            EntryOption: 0,
            ExitOption: 0
        });
        selChangeWF.Data.Connectors.push({
            ExitModule: selSetVarModule.ID,
            EntryModule: selDataSwitchModule.ID,
            EntryOption: 0,
            ExitOption: 0
        });
        selChangeWF.Data.Connectors.push({
            ExitModule: selDataSwitchModule.ID,
            EntryModule: selSetNameStyleModule.ID,
            EntryOption: 0,
            ExitOption: 1
        });
        selChangeWF.Data.Connectors.push({
            ExitModule: selDataSwitchModule.ID,
            EntryModule: selSetPWStyleModule.ID,
            EntryOption: 0,
            ExitOption: 2
        });
        selChangeWF.Data.Connectors.push({
            ExitModule: selSetNameStyleModule.ID,
            EntryModule: selSetPWStyleModule.ID,
            EntryOption: 0,
            ExitOption: 0
        });

        l.Workflows.push(selChangeWF);

        providerBox.Events.push({
            EventID: 'selectionchanged',
            Handlers: [
                {
                    ActionType: EventActionType.Workflow,
                    Action: selChangeWF.ID
                }
            ]
        });
        //#endregion        
        //#endregion

        return l;
    }

    public static GetLoginGrid(name: string, rowIndex: number): LayoutElement {
        const grid = LoginLayoutHelper.GetLayoutElement(name, 'grid');
        grid.Row = rowIndex;
        const firstCol = new LayoutBase();
        firstCol.Size = LoginLayoutHelper.GetLayoutUnit(UnitType.Auto, 1);
        const secondCol = new LayoutBase();
        secondCol.Size = LoginLayoutHelper.GetLayoutUnit(UnitType.fr, 1);
        grid['ColumnDefinitions'] = [firstCol, secondCol];
        const firstRow = new LayoutBase();
        firstRow.Size = LoginLayoutHelper.GetLayoutUnit(UnitType.Auto, 1);
        const secondRow = new LayoutBase();
        secondRow.Size = LoginLayoutHelper.GetLayoutUnit(UnitType.Auto, 1);
        grid['RowDefinitions'] = [firstRow, secondRow];
        return grid;
    }

    public static GetWFDescription(caption: string, id: string, startModuleID: number): WorkflowDescription {
        const retVal = new WorkflowDescription();
        retVal.Caption = caption;
        retVal.ID = id;
        retVal.Data = new WorkflowData();

        const startData = new StartWfModuleData();
        const startModule = LoginLayoutHelper.GetWFModule(startModuleID);
        startModule.Module = StartWfModuleSettings.ModuleID;
        startModule.Settings = startData;
        retVal.Data.Modules.push(startModule);

        return retVal;
    }

    public static GetWFModule(id: number): WorkflowModuleData {
        const retVal = new WorkflowModuleData();
        retVal.ID = id;
        const idMod = id % 4;
        retVal.XPos = 50 + Math.floor(id / 4) * 285 + idMod * 25;
        retVal.YPos = 50 + idMod * 150;
        return retVal;
    }

    public static SetBorder(element: LayoutElement, borderWidth: number, borderStyle: BorderStyle, colorHex: string) {
        element.Border = new Border();
        element.Border.LeftBorder = LoginLayoutHelper.GetBorderSide(borderWidth, borderStyle, colorHex);
        element.Border.TopBorder = LoginLayoutHelper.GetBorderSide(borderWidth, borderStyle, colorHex);
        element.Border.RightBorder = LoginLayoutHelper.GetBorderSide(borderWidth, borderStyle, colorHex);
        element.Border.BottomBorder = LoginLayoutHelper.GetBorderSide(borderWidth, borderStyle, colorHex);
        element['UseBorder'] = true;
    }

    private static GetBorderSide(borderWidth: number, borderStyle: BorderStyle, colorHex: string): BorderSide {
        const retVal = new BorderSide();
        retVal.Color = Gradient.Solid(Color.FromHex(colorHex));
        retVal.Style = borderStyle;
        retVal.Thickness = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, borderWidth);
        return retVal;
    }

    public static SetBorderRadius(border: Border, radius: number) {
        border.BorderRadius.TopLeft = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, radius);
        border.BorderRadius.TopRight = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, radius);
        border.BorderRadius.BottomRight = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, radius);
        border.BorderRadius.BottomLeft = LoginLayoutHelper.GetLayoutUnit(UnitType.Pixel, radius);
    }

    public static GetLayoutElement(name: string, elementType: string, visible: boolean = true): LayoutElement {
        const retVal = new LayoutElement();
        retVal.Visible = visible;
        retVal.Name = name;
        retVal.ElementType = elementType;
        return retVal;
    }

    public static GetLayoutUnit(type: UnitType, value: number): LayoutUnit {
        const retVal = new LayoutUnit();
        retVal.Type = type;
        retVal.Value = value;
        return retVal;
    }
}
